export default __webpack_public_path__ + "static/2_15-e407f49e0fa57e6aa43d5be75e1aac57.png";